<footer class="footer">
  <div class="footer-content">
    <span>© Woolworths Ltd. 2024. All rights reserved.</span>
  </div>
</footer>
